"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _consts = _interopRequireDefault(require("./consts"));

var getSpacingToken = function getSpacingToken(_ref) {
  var _tokens;

  var spaceAfter = _ref.spaceAfter,
      theme = _ref.theme;
  var tokens = (_tokens = {}, (0, _defineProperty2.default)(_tokens, _consts.default.NONE, "0"), (0, _defineProperty2.default)(_tokens, _consts.default.SMALLEST, theme.orbit.spaceXXSmall), (0, _defineProperty2.default)(_tokens, _consts.default.SMALL, theme.orbit.spaceXSmall), (0, _defineProperty2.default)(_tokens, _consts.default.NORMAL, theme.orbit.spaceSmall), (0, _defineProperty2.default)(_tokens, _consts.default.MEDIUM, theme.orbit.spaceMedium), (0, _defineProperty2.default)(_tokens, _consts.default.LARGE, theme.orbit.spaceLarge), (0, _defineProperty2.default)(_tokens, _consts.default.LARGEST, theme.orbit.spaceXLarge), _tokens);
  return spaceAfter && tokens[spaceAfter];
};

var _default = getSpacingToken;
exports.default = _default;